<template>
  <div class="donation">
    <PageBanner />
    <Breadcrumbs />

    <section class="content">
      <div class="container">
        <p>您的慷慨捐助，能支持本會開展計劃，以實現用教育解決跨代貧窮之願景。</p>
        <p class="h5">以劃線支票捐款</p>
        <p>請將劃線支票（支票抬頭為「共享教育基金有限公司」或「Open Education Foundation Limited」），郵寄至共享教育基金辦事處 - 香港皇后大道西111號華富商業中心702室。</p>
        <p class="h5">銀行直接存款</p>
        <p>請將捐款直接存入「共享教育基金公司」以下戶口：<br>
          中國銀行(香港) 012-875-1-252479-2</p>
      </div>
    </section>
  </div>
</template>

<script>
  import PageBanner from "@/components/pageBanner.vue";
  import Breadcrumbs from "@/components/breadcrumbs.vue";
  export default {
    name: "Donation",
    components: {
      PageBanner,
      Breadcrumbs
    }
  };
</script>